import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalsComponent } from './modals.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { RequiredActionsModalComponent } from './required-actions-modal/required-actions-modal.component';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import {
  EnableTemporaryOTPModalComponent
} from './auth-modals/enable-temporary-otp-modal/enable-temporary-otp-modal.component';
import {TemporaryOTPModalComponent} from './auth-modals/temporary-otp-modal/temporary-otp-modal.component';

@NgModule({
  declarations: [
    ModalsComponent,
    RequiredActionsModalComponent,
    ConfirmationModalComponent,
    SuccessModalComponent,
    EnableTemporaryOTPModalComponent,
    TemporaryOTPModalComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ModalsModule { }
